"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightPanelStack = exports.Wrap = exports.FilterTag = exports.FiltersStack = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.FiltersStack = (0, app_1.styled)(ui_1.Stack) `
  margin-left: auto !important;
`;
exports.FilterTag = (0, app_1.styled)(ui_1.Tag) `
  border: 1px solid ${(theme) => theme.colors.primary};
  color: ${(theme) => theme.colors.primary};
  background-color: transparent;
  svg {
    fill: ${(theme) => theme.colors.primary};
    color: ${(theme) => theme.colors.primary};
  }
`;
exports.Wrap = (0, app_1.styled)(ui_1.Grid) `
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
exports.RightPanelStack = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
  ${(_, { $searching }) => $searching &&
    (0, app_1.css) `
      width: 100%;
      > div {
        width: 100%;
      }
    `}
`;
